export default "/images/view.png?f13a83b58622772ce12bc794dbee20e9";